import React from "react";

/**
 * The Entity Agency brand mark.
 *
 * Two layouts:
 *  - layout="full"        (default) the complete portrait lockup with tagline
 *                         (E + THE ENTITY AGENCY + "AI VISIBILITY. ENTITY
 *                         CLARITY. REAL RESULTS." tagline)
 *  - layout="horizontal"  E + THE ENTITY AGENCY only, no tagline (for nav bars)
 *
 * `size` controls the rendered HEIGHT in px. Width is auto from the asset.
 *
 * `variant`: "light" (default, for dark bg) or "dark" (for cream/paper).
 */
export default function BrandMark({
  size = 60,
  layout = "full",
  variant = "light",
  className = "",
}) {
  const map = {
    "full-light":      "/brand/entity-agency-logo-light.png",
    "full-dark":       "/brand/entity-agency-logo-transparent.png",
    "horizontal-light": "/brand/entity-agency-logo-horizontal-light.png",
    "horizontal-dark":  "/brand/entity-agency-logo-horizontal.png",
  };
  const src = map[`${layout}-${variant}`] || map["full-light"];

  return (
    <div
      className={`inline-flex items-center ${className}`}
      style={{ height: size }}
      data-testid="brand-mark"
    >
      <img
        src={src}
        alt="The Entity Agency — AI Visibility · Entity Clarity · Real Results"
        style={{ height: size, width: "auto", display: "block" }}
        draggable={false}
      />
    </div>
  );
}
